//styles
import './sass/system.scss';
import './sass/_globals.scss';
import './sass/wp-classes.scss';
import './sass/layout.scss';
import './sass/components/header.scss';
import './sass/components/footer.scss';
import './sass/components/_c7.scss';


jQuery(document).ready(function () {
 //-----ResNav----->
 jQuery("#nav-icon").on("mousedown touch", function () {
    jQuery("#nav-icon").toggleClass("open");
    jQuery("#ResNav").toggleClass("open");
    jQuery("header").toggleClass("menu-open");
  });
  jQuery("#ResNav li.menu-item-has-children a").on("click", function (e) {
    e.preventDefault();
    console.log(jQuery(this));
    jQuery(this).parent().find('.sub-menu:first').toggleClass("open");
  });
  //-----ResNav----->
});